export default function initializeTaxamo(publicAuthToken) {
  if (!('Taxamo' in window)) {
    console.error('Taxamo not found; nothing we can do here');
    return;
  }
  const { Taxamo } = window;
  Taxamo.initialize(publicAuthToken);
  // These need are set to false initially in the Taxamo docs:
  // https://www.taxamo.com/doc/taxamojs/dynamic_pricing/
  // They do not explain why.
  window.Taxamo.options.scanPrices.noTaxTitle = false; // will be overwritten below
  window.Taxamo.options.scanPrices.taxTitle = false; // will be overwritten below
}